import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React, { useState } from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import styled from 'styled-components'

/**
 * テキストエリア本体
 */
const TextBox: React.FC<TextBoxProps> = (props) => {
  const [isFocus, setFocus] = useState(false)
  return (
    <React.Fragment>
      <StyledTextBox
        className={props.className}
        value={props.inputText}
        placeholder={props.placeholder}
        maxLength={props.maxLength}
        onChange={props.onChange}
        onFocus={(): void => {
          setFocus(true)
        }}
        onBlur={(): void => {
          setFocus(false)
        }}
      />
      {/* テキストボックス選択時もしくは入力済みの場合、プレースホルダーは左上に表示する */}
      {props.doNotPlaceholderMove
        ? ''
        : (isFocus || props.inputText !== '') && (
            <StyledInput>{props.placeholder}</StyledInput>
          )}
    </React.Fragment>
  )
}

export type TextBoxProps = {
  inputText: string
  placeholder?: string
  maxLength?: number
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
  className?: string
  doNotPlaceholderMove?: boolean
}

//テキストボックスのスタイル
export const StyledTextBox = styled(TextareaAutosize)`
  width: calc(100% - 32px);
  margin: 16px 16px 10px;
  padding: 20px 0 10px;
  font-size: 16px;
  border-top: none;
  border-right: none;
  border-bottom: 1px solid ${CLIENT_SETTINGS.colors.text}33;
  border-left: none;
  background-color: transparent;
  outline: none;
  resize: none;

  ::placeholder {
    color: ${CLIENT_SETTINGS.colors.text}80;
  }
  :focus {
    border-bottom: 1px solid ${CLIENT_SETTINGS.colors.main}a3;
    ::placeholder {
      color: rgba(0, 0, 0, 0);
    }
  }
`

//テキストボックス入力時のプレースホルダーのスタイル
export const StyledInput = styled.div`
  position: absolute;
  top: 12px;
  left: 18px;
  color: ${CLIENT_SETTINGS.colors.text}80;
  font-size: 12px;
`

export default TextBox
